import { render, staticRenderFns } from "./paginaiton.vue?vue&type=template&id=4fea4e3d"
import script from "./paginaiton.vue?vue&type=script&lang=ts"
export * from "./paginaiton.vue?vue&type=script&lang=ts"
import style0 from "./paginaiton.vue?vue&type=style&index=0&id=4fea4e3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports